function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 24v-8h1v8h4v-8h1v8a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 14a1 1 0 0 0-1 1v3.75l1.8 1.35-.6.8-1.8-1.35a1 1 0 0 1-.4-.8V15a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3.75a1 1 0 0 1-.4.8l-1.8 1.35-.6-.8 1.8-1.35V15a1 1 0 0 0-1-1H9zm1-6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V8zm3 0h-2v3h2V8zm8 9a1 1 0 0 0-1 1v2.293l.707.707a1 1 0 0 1 .293.707V24h2v-2.293a1 1 0 0 1 .293-.707l.707-.707V18a1 1 0 0 0-1-1h-2zm-2 1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2.293a1 1 0 0 1-.293.707l-.707.707V24a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2.293L19.293 21a1 1 0 0 1-.293-.707V18zm1-6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2zm3 0h-2v2h2v-2z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.9b4e36d53c15bde124b924dbe647a5d9.svg";
export { ForwardRef as ReactComponent };